import React from "react";
import { Button } from "../../components/Button/Button";
import ModalBox from "../../components/modal/ModalBox";

const ImageModal = ({ showModal, closeModal, imageUrl, title = "Profile" }) => {
    return (
        <ModalBox
            status={showModal}
            onClose={() => closeModal(false)}
            title={title}
            custom
            size={"md"}
            customizedFooter={
                <Button className='btn_size' onClick={() => closeModal(false)}>Close</Button>
            }
        >
            <div>
                <img className='w-100' src={imageUrl} alt="" />
            </div>
        </ModalBox>
    );
};

export default ImageModal;

// In another component, you can use ImageModal like this:
// {<ImageModal showModal={showImgModal} closeModal={setShowImgModal} imageUrl={imageUrl} title="User Image" />}
